import React from "react";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import TabLayout from "src/components/base/tab-layout";
import { Tab, TabMenu } from "src/components/base/tab-menu";

/**
 * The properties for {@link SubnetTabs}
 */
export type SubnetTabsProps = {};

/**
 * Tabs for the device view
 */
function SubnetTabs(props: SubnetTabsProps) {
    const [t] = useTranslation("admin-subnets");

    return (
        <TabLayout
            heading={t("heading.subnets")}
            headingDescription={t("description.subnets")}
            tabs={
                <TabMenu>
                    <Tab href={"/a/subnets/approved"}>{t("heading.approved")}</Tab>
                    <Tab href={"/a/subnets/pending"}>{t("heading.pending")}</Tab>
                </TabMenu>
            }
        >
            <Outlet />
        </TabLayout>
    );
}

export const Route = createFileRoute("/_admin/a/subnets/_subnets")({
    component: SubnetTabs,
});
